// extracted by mini-css-extract-plugin
export var dataCell = "_mq-2";
export var dataRow = "_mq-0";
export var headerRow = "_mq-1";